import { IconBan, IconCheck } from "@tabler/icons-react";
import { Card, Group, Heading, Stack, Text, ThemeIcon } from "@/components/ui";
import type { SolicitudDetalle } from "@/lib/types";

/**
 * Card de estado terminal del FLUJO de autorización (la solicitud quedó
 * autorizada en todos los niveles, o fue dada de baja). Si fue baja,
 * muestra los motivos para auditabilidad.
 *
 * Cuando `autorizada`, esto NO implica que ya no haya acciones: Mesa de
 * Control aún puede dar de baja la solicitud (decisión P29) · en ese caso
 * `AutorizacionDetallePage` muestra esta card JUNTO a
 * `AccionesAutorizadorCard`, no en su lugar. Si fue dada de baja, ese
 * estado sí es 100% terminal sin ninguna acción disponible.
 */
export function AutorizacionTerminadaCard({ sol }: { sol: SolicitudDetalle }) {
  const autorizada = sol.estado === "Autorizada";
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group gap="sm">
          <ThemeIcon size="md" radius="md" variant="light" color={autorizada ? "exito" : "peligro"}>
            {autorizada ? <IconCheck size={20} stroke={1.8} /> : <IconBan size={20} stroke={1.7} />}
          </ThemeIcon>
          <Heading order={5}>{autorizada ? "Autorizada" : "Baja por Mesa de Control"}</Heading>
        </Group>
        {!autorizada && sol.dadaDeBajaPorNombre ? (
          <Text size="sm">
            Dada de baja por{" "}
            <Text span fw={600}>
              {sol.dadaDeBajaPorNombre}
            </Text>{" "}
            (Mesa de Control).
          </Text>
        ) : null}
        {!autorizada && sol.motivosBaja.length > 0 ? (
          <div>
            <Text size="sm" fw={600} className="mb-1">
              Motivos:
            </Text>
            <ul className="list-disc space-y-0.5 pl-5 text-sm">
              {sol.motivosBaja.map((m, i) => (
                <li key={i}>{m}</li>
              ))}
            </ul>
          </div>
        ) : null}
      </Stack>
    </Card>
  );
}
